import React from "react";

const SvgBBiconsVi = props => (
  <svg viewBox="0 0 200 200" {...props}>
    {props.title && <title>{props.title}</title>}
    <g data-name="Obecn\xE9 ikony">
      <g data-name="Varovne informace">
        <path d="M55.87 171.51a6.69 6.69 0 01-2.67-12.83l88.27-38.31a6.69 6.69 0 015.33 12.28L58.53 171a6.61 6.61 0 01-2.66.51zM100 28.49c-25.58 0-46.3 19-46.3 42.45 0 15.87 9.51 29.67 23.58 37a15.22 15.22 0 00-.47 3.37c0 6.25 3.46 11.31 7.72 11.31 3.92 0 7-4.33 7.54-9.85h.25v.3c0 6.25 3.45 11.31 7.72 11.31s7.74-5.06 7.74-11.31v-.3h.26c.5 5.52 3.59 9.85 7.51 9.85 4.27 0 7.72-5.06 7.72-11.31a15.22 15.22 0 00-.47-3.37c14.07-7.29 23.6-21.09 23.6-37-.09-23.44-20.83-42.45-46.4-42.45zM83.79 65.54c5.1 0 9.23 4.53 9.23 10.09s-4.13 10.08-9.23 10.08-9.24-4.51-9.24-10.08 4.14-10.09 9.24-10.09zm32.43 0c5.1 0 9.22 4.53 9.22 10.09s-4.12 10.08-9.22 10.08S107 81.2 107 75.63s4.12-10.09 9.22-10.09z" />
        <path d="M144.13 171.51a6.61 6.61 0 01-2.66-.55L53.2 132.65a6.69 6.69 0 015.33-12.28l88.27 38.31a6.69 6.69 0 01-2.67 12.83z" />
      </g>
    </g>
  </svg>
);

export default SvgBBiconsVi;
